import React, { useContext } from 'react';
import { MsalContext } from '@azure/msal-react';
import { PublicClientApplication, EventType, InteractionStatus } from '@azure/msal-browser';
import { msalConfig } from './authConfig';

function isSecureBrowserContext() {
  if (typeof window === 'undefined') {
    return false;
  }

  const host = window.location.hostname;
  return window.isSecureContext || host === 'localhost' || host === '127.0.0.1';
}

let msalInstance = null;
let msalEnabled = false;
let msalUnavailableReason = '';

try {
  if (!isSecureBrowserContext()) {
    msalUnavailableReason = 'Microsoft sign-in requires HTTPS or localhost.';
  } else {
    msalInstance = new PublicClientApplication(msalConfig);
    msalEnabled = true;

    if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
      msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
    }

    msalInstance.addEventCallback((event) => {
      if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.account) {
        msalInstance.setActiveAccount(event.payload.account);
      }
    });
  }
} catch (error) {
  msalInstance = null;
  msalEnabled = false;
  msalUnavailableReason = error?.message || 'Microsoft sign-in is unavailable in this browser context.';
}

export { InteractionStatus, msalEnabled, msalInstance, msalUnavailableReason };

export function useSafeMsal() {
  const context = useContext(MsalContext);

  if (msalEnabled && context) {
    return context;
  }

  return {
    instance: null,
    accounts: [],
    inProgress: InteractionStatus.None,
  };
}
